import React from 'react';

import { SearchContext } from './search-context';
import '../css/search-results.less';

export default class SearchResults extends React.Component {
    static defaultProps = {
        element: 'div'
    }

    render() {
        const { element, className, ...rest} = this.props;
        return (
            <SearchContext.Consumer>
             {
                ({results, paginationEnabled, currentPage, disableSearch, searchInProgress, query}) => {
                    const classNameAgg = `search-results${searchInProgress ? ' searching' : ''}${className ? ' ' + className : ''}`
                    //TODO: if pagination enable only provide current page
                    return  React.createElement(
                                element, 
                                { 
                                    className: classNameAgg, 
                                    ...rest 
                                }, 
                                this.props.children({ results, disableSearch, query, searchInProgress })
                            )
                }
            }
            </SearchContext.Consumer>
        );
    }

}
